//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      isLoading: false
    }
  },

  props: {
    service: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    name: function () {
      return this.service?.name || ''
    },
    imageId: function () {
      return String(this.service?.image_id || '')
    },
    bannerText: function () {
      return this.service?.banner_text || ''
    },
    description: function () {
      return this.service?.description || ''
    },
    information: function () {
      let list = [];

      const services = (this.service?.services || []).map((t) => t?.name || '').filter((t) => !!t).join(', ');
      if (!!services) {
        list.push({
          label: this.$t('partner.price_regulator.services'),
          value: services,
          isFull: true
        });
      }

      if (Number.parseFloat(this.service?.activations || '0') > 0) {
        list.push({
          label: this.$t('soft.activations'),
          value: this.$numberFormat(this.service?.activations || 0),
          isFull: false
        });
      }

      const priceCurrency = this.$convertCurrency(this.service?.price_from || 0);
      const iconCurrency = Boolean(this.$store.getters["currency/currentCurrency"] === 'rub') ? '₽' : '$';
      list.push({
        label: this.$t('serviceCard.price'),
        value: `${this.$t('servicesList.from')} ${this.$numberFormat(priceCurrency)} ${iconCurrency}`,
        isFull: false
      });

      return list
    },
  }
}
